import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { Text } from '../../ui-kit/Text/Text.js';
import { style } from '../../utils/style.js';
import { CardCell } from './CardCell.js';
import { CardRow } from './CardRow.js';
import { WEEKDAY_MAP } from './getWorkScheduleWeek.js';
export const renderBusinessSchedule = (scheduleDescription) => {
    if (!scheduleDescription) {
        return null;
    }
    const businessSchedule = getBusinessSchedule(scheduleDescription);
    return (_jsxs(CardRow, { className: "border-none", children: [_jsx(CardCell, { label: "\u0414\u043B\u044F \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u043B\u0438\u0446", labelSize: "text-l", children: _jsx("div", { className: "flex gap-1", children: businessSchedule.map(renderAlternativeDay) }) }), _jsx(CardCell, { label: "\u0420\u0435\u0436\u0438\u043C \u0440\u0430\u0431\u043E\u0442\u044B", className: "max-w-none", children: _jsx(Text, { children: scheduleDescription }) })] }));
};
export const getBusinessSchedule = (scheduleDescription) => {
    const weekDayMap = WEEKDAY_MAP.map(([, short]) => ({ short, status: true }));
    const splittedScheduleDescription = scheduleDescription.split('/') ?? [];
    const lastPartScheduleDescription = splittedScheduleDescription[splittedScheduleDescription.length - 1]?.toLowerCase();
    if (!lastPartScheduleDescription?.includes('выходной')) {
        return weekDayMap;
    }
    return weekDayMap.map((_) => ({
        ..._,
        status: !lastPartScheduleDescription?.includes(_.short.toLowerCase()),
    }));
};
export const renderAlternativeDay = ({ short, status }, i) => (_jsx("div", { className: style('w-9 h-9 rounded-md flex items-center justify-center', status ? 'bg-green-more-light text-green-dark' : 'bg-error/30 text-error'), children: _jsx(Text, { size: "text-xs", children: short }) }, String(i)));
//# sourceMappingURL=renderBusinessSchedule.js.map